import AbstractInterface from './abstractInterface';

export default class AbstractClass implements AbstractInterface {
    id: string;

    constructor(id: string) {
        this.id = id;
    }

    toJSON(): Record<string, any> {
        return {
            id: this.id
        };
    }
}
